/** Split `company_server_SYMBOL` cache key into account + symbol parts. */
export function splitAccountSymbolKey(fullKey: string): {
  accountKey: string;
  symbol: string;
} {
  const lastUnderscore = fullKey.lastIndexOf("_");
  if (lastUnderscore <= 0) {
    return { accountKey: fullKey, symbol: "" };
  }
  return {
    accountKey: fullKey.slice(0, lastUnderscore),
    symbol: fullKey.slice(lastUnderscore + 1),
  };
}

export function makeSymbolRevisionKey(
  accountKey: string,
  symbol: string,
): string {
  return `${accountKey}|${symbol}`;
}
